import React from "react";
import akmApi from "../../../../../apis/akmApi";
import { normalizeNpsn } from "./npsnRules";

export default class SchoolNpsnEditor extends React.Component {
    state = { draft: "", expected: null, loading: true, ready: false, message: "" };
    sequence = 0;
    saving = false;
    componentDidMount() { this.load(); }
    componentDidUpdate(previous) { if (previous.schoolId !== this.props.schoolId) this.load(); }
    componentWillUnmount() { this.sequence += 1; }
    endpoint = () => `/sekolah/${this.props.schoolId}/npsn`;
    load = async () => {
        const sequence = ++this.sequence;
        this.setState({ draft: "", expected: null, loading: true, ready: false, message: "" });
        try {
            const response = await akmApi.get(this.endpoint(), { timeout: 15000 });
            if (sequence !== this.sequence) return;
            const value = response.data && response.data.data;
            if (!response.data.errorSchema || response.data.errorSchema.errorCode !== "EP-000" || !value || String(value.idSekolah) !== String(this.props.schoolId)) throw new Error("invalid response");
            this.setState({ draft: value.npsn || "", expected: value.npsn, loading: false, ready: true });
        } catch (error) {
            if (sequence === this.sequence) this.setState({ loading: false, ready: false, message: "NPSN belum dapat dimuat. Muat ulang atau hubungi admin sistem." });
        }
    };
    save = async event => {
        event.preventDefault();
        if (this.saving) return;
        const npsn = normalizeNpsn(this.state.draft);
        if (!this.state.ready || this.state.loading || !npsn) {
            this.setState({ message: "Isi 8 karakter huruf atau angka sesuai NPSN resmi sekolah." });
            return;
        }
        const sequence = this.sequence;
        this.saving = true;
        this.setState({ loading: true, message: "" });
        try {
            const response = await akmApi.put(this.endpoint(), { npsn, expectedNpsn: this.state.expected }, { timeout: 20000 });
            if (sequence !== this.sequence) return;
            const value = response.data && response.data.data;
            if (!response.data.errorSchema || response.data.errorSchema.errorCode !== "EP-000" || !value || String(value.idSekolah) !== String(this.props.schoolId) || value.npsn !== npsn) throw new Error("invalid response");
            this.setState({ draft: value.npsn, expected: value.npsn, loading: false, message: "NPSN tersimpan. Cocokkan dengan data referensi resmi sebelum ujian." });
        } catch (error) {
            if (sequence !== this.sequence) return;
            const code = error.response && error.response.data && error.response.data.data && error.response.data.data.code;
            const message = code === "NPSN_DUPLICATE" ? "NPSN sudah dipakai sekolah lain. Periksa data referensi." :
                code === "NPSN_CHANGED" ? "NPSN diubah admin lain. Muat ulang sebelum menyimpan." :
                    "NPSN belum dapat dipastikan tersimpan. Muat ulang untuk memeriksa hasil sebelum mencoba kembali.";
            this.setState({ loading: false, ready: false, message });
        } finally {
            this.saving = false;
        }
    };
    render() {
        return <form onSubmit={this.save} className="my-3 border rounded p-3" aria-label="NPSN sekolah">
            <label htmlFor="school-npsn">NPSN sekolah</label>
            <div className="d-flex flex-wrap align-items-center">
                <input id="school-npsn" aria-describedby="school-npsn-help" className="form-control mr-2 mb-2" style={{ maxWidth: "220px" }}
                    type="text" autoComplete="off" maxLength={8} value={this.state.draft}
                    onChange={event => this.setState({ draft: event.target.value.toUpperCase() })} disabled={this.state.loading || !this.state.ready} />
                <button className="btn btn-primary mr-2 mb-2" type="submit" disabled={this.state.loading || !this.state.ready}>Simpan NPSN</button>
                <button className="btn btn-outline-secondary mb-2" type="button" onClick={this.load} disabled={this.state.loading}>Muat ulang</button>
            </div>
            <small id="school-npsn-help">Isi sesuai referensi resmi sekolah. Kosong berarti belum diisi; NPSN tidak dibuat otomatis.</small>
            {this.state.message && <div role="status" className="mt-2">{this.state.message}</div>}
        </form>;
    }
}
